module.exports = __webpack_public_path__ + "i18n/ko_566177789593bfa9fd83aad8cde7a6ca.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ko.json
// module id = a8i3
// module chunks = 153